import { createSlotsContext } from '@grandvisionhq/slots';

const [PersonalDetailsFormSlotsProvider, usePersonalDetailsFormSlots] = createSlotsContext({
    displayName: 'PersonalDetailsFormSlotsContext'
});

export { PersonalDetailsFormSlotsProvider, usePersonalDetailsFormSlots };
//# sourceMappingURL=PersonalDetailsFormSlotsContext.js.map
